import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import { useGoogleAnalytics } from "./hooks/useGoogleAnalytics";
import NotFound from "pages/NotFound";
import BuyerDashboard from './pages/buyer-dashboard';
import AuthenticationScreen from './pages/authentication-screen';
import DealRoomPage from './pages/deal-room-page';
import TravelerDashboard from './pages/traveler-dashboard';
import TravelerTripCreation from './pages/traveler-trip-creation';
import PaymentScreen from './pages/payment-screen';
import TravelerProfile from './pages/traveler-profile';
import UnifiedDashboard from './pages/unified-dashboard';
import AIMonitoringDashboard from './pages/ai-monitoring-dashboard';
import AdminAuthentication from './pages/admin-authentication';
import AdminPanelDashboard from './pages/admin-panel-dashboard';
import AdminUserManagement from './pages/admin-user-management';
import NotificationsHub from './pages/notifications-hub';

const RoutesContent = () => {
  useGoogleAnalytics();
  
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AuthenticationScreen />} />
        <Route path="/buyer-dashboard" element={<BuyerDashboard />} />
        <Route path="/authentication-screen" element={<AuthenticationScreen />} />
        <Route path="/deal-room-page" element={<DealRoomPage />} />
        <Route path="/traveler-dashboard" element={<TravelerDashboard />} />
        <Route path="/traveler-trip-creation" element={<TravelerTripCreation />} />
        <Route path="/payment-screen" element={<PaymentScreen />} />
        <Route path="/traveler-profile/:id" element={<TravelerProfile />} />
        <Route path="/unified-dashboard" element={<UnifiedDashboard />} />
        <Route path="/ai-monitoring-dashboard" element={<AIMonitoringDashboard />} />
        <Route path="/admin-authentication" element={<AdminAuthentication />} />
        <Route path="/admin-panel-dashboard" element={<AdminPanelDashboard />} />
        <Route path="/admin-user-management" element={<AdminUserManagement />} />
        <Route path="/notifications-hub" element={<NotificationsHub />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </ErrorBoundary>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RoutesContent />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
